var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomWallet = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.878 19.88c-1.551 0-2.813-1.292-2.813-2.88 0-1.588 1.262-2.88 2.813-2.88h3.282v-4.8c0-.265-.21-.48-.469-.48H6.344c-.775 0-1.406-.646-1.406-1.44 0-.794.63-1.44 1.406-1.44h12.659v1.92h.937v-2.4c0-.265-.21-.48-.468-.48H6.344C5.052 5 4 6.077 4 7.4v14.4c0 1.853 1.472 3.36 3.282 3.36h16.41a.475.475 0 0 0 .468-.48v-4.8h-3.282z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.137 15.08h-4.166c-1.02 0-1.851.807-1.851 1.8s.83 1.8 1.851 1.8h4.166a.457.457 0 0 0 .463-.45v-2.7a.457.457 0 0 0-.463-.45z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-wallet.2492d597eb9087e991f0c785dc06e565.svg";